import { Enviroment } from '../../../../../../_config/constants/enviroment-v2.constant';
import { getStatusNumber } from './get-status-number.handle';

export const getStatusDetail = (status, deliveryType,products) => {
	return status.status ? getStatusNumber(deliveryType,products)[Enviroment.LANGUAGE][status.status] : 'Estado de solicitud no reconocido';
};
